import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTourExpCreditBenefitsModal from './LandingPageLoyaltyTourExpCreditBenefitsModal'

const image: App.Image = {
  id: '69vg83q7obl8xw4x1ac',
  title: 'Extras on your tour',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTourExpCredit(props: Props) {
  const { tier, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTourExpCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [showModal, benefit])

  return <LandingPageLoyaltyBenefitTile
    heading="Extras on your tour"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Enjoy extra perks on your next adventure with a travel credit towards tour add-ons.{' '}
      Whether it's a sunset cruise or a food tour, these extras are on us.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyTourExpCredit
